import { cn, platformProps } from "../../lib";
import {
  tagRibbonTailColor,
  tagRibbonTailHeight,
  tagRibbonTailPath,
  tagRibbonTailWidth,
} from "./lib";
import type { TagRibbonPosition, TagRibbonSize, TagRibbonState } from "./types";

interface TagRibbonTailProps {
  state: TagRibbonState;
  size: TagRibbonSize;
  position: TagRibbonPosition;
}

/** The fold under the ribbon's outer end. Decorative. */
export const TagRibbonTail = ({ state, size, position }: TagRibbonTailProps) => (
  <svg
    width={tagRibbonTailWidth[size]}
    height={tagRibbonTailHeight}
    viewBox={`0 0 16 ${tagRibbonTailHeight}`}
    preserveAspectRatio="none"
    aria-hidden
    {...platformProps({ slot: "tag-ribbon-tail" })}
    className={cn(
      "pointer-events-none absolute top-full",
      position === "left" ? "left-0" : "right-0",
    )}
  >
    <path d={tagRibbonTailPath[position]} fill={tagRibbonTailColor[state]} />
  </svg>
);
